export enum ForecastOptions {
  Today = 'today',
  Tomorrow = 'tomorrow',
  DayAfterTomorrow = 'dayAfterTomorrow',
}